"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/catch");
var DealerBlockBidService = (function () {
    function DealerBlockBidService(httpClient) {
        this.httpClient = httpClient;
        this.loadBidHistoryHandler = new core_1.EventEmitter();
    }
    DealerBlockBidService.prototype.showBidHistory = function (vehicleId$) {
        var _this = this;
        var bidHistoryDto = {
            isLoading: true,
            nwVehicleId: vehicleId$,
            bids: null,
            error: null,
            bidCount: 0,
            bidderCount: 0,
            previewType: null,
            showBidderName: false
        };
        this.loadBidHistoryHandler.emit(bidHistoryDto);
        this.loadBidHistory(vehicleId$).subscribe(function (data) {
            bidHistoryDto.bidCount = data.bidCount;
            bidHistoryDto.bidderCount = data.bidderCount;
            bidHistoryDto.bids = data.bids;
            bidHistoryDto.isLoading = false;
            bidHistoryDto.previewType = data.previewType;
            bidHistoryDto.showBidderName = data.showBidderName;
            _this.loadBidHistoryHandler.emit(bidHistoryDto);
        }, function (error) {
            bidHistoryDto.isLoading = false;
            bidHistoryDto.bids = null;
            bidHistoryDto.error = true;
            _this.loadBidHistoryHandler.emit(bidHistoryDto);
        });
    };
    DealerBlockBidService.prototype.loadDelerBlockBidHistory = function () {
        return this.loadBidHistoryHandler;
    };
    DealerBlockBidService.prototype.loadBidHistory = function (vehicleId$) {
        return this.httpClient.get("/api/dealerblock/vehicles/" + vehicleId$ + "/bids")
            .map(function (res) { return res; })
            .catch(function (error) {
            return Observable_1.Observable.throw(error);
        });
    };
    return DealerBlockBidService;
}());
DealerBlockBidService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
DealerBlockBidService.ctorParameters = function () { return [
    { type: http_1.HttpClient, },
]; };
exports.DealerBlockBidService = DealerBlockBidService;
//# sourceMappingURL=dealerblock-bid.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/shared/services/dealerblock-bid.service.js
// module id = peop
// module chunks = 0